// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/inventory.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { InventoryService } from "./inventory_pb";

/**
 * Admin-only counts (VPCs, Storage) are unset for non-admins.
 *
 * @generated from rpc chalk.server.v1.InventoryService.GetTeamNavbarCounts
 */
export const getTeamNavbarCounts = InventoryService.method.getTeamNavbarCounts;

/**
 * @generated from rpc chalk.server.v1.InventoryService.GetProjectNavbarCounts
 */
export const getProjectNavbarCounts = InventoryService.method.getProjectNavbarCounts;
